/**
 * Base URL for the cogo-starter runtime SPA.
 * Used by template preview iframes and the /preview/ sub-path.
 *
 * In production, VITE_STARTER_URL should be explicitly set in
 * Cloudflare Pages env vars. The fallback 'https://cogo-starter.pages.dev'
 * points to the separate Cloudflare Pages deployment of cogo-starter.
 *
 * WARNING: Do NOT change the fallback to 'https://cogo.xyz' -- that would
 * cause recursive iframe loading (see FIND-001 in 397-UX-FINDINGS.md).
 */
export const STARTER_BASE = import.meta.env.VITE_STARTER_URL ?? 'https://cogo-starter.pages.dev'
